function FutureLexPage(){
    return <div>
    <div>
        About futurelex
    </div>
</div>
}

export default FutureLexPage;